import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "error"];
import { useQuery, registerQuery, useDataFetchingClient } from 'data-fetching-client';
import { useDraftContext } from 'crm-index-visualization-core/core/data/VizCoreProvider';
import { useEffect, useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { writeViewToCache } from './useView';
const getPinnedViewDefinitions = ({
  objectTypeId,
  count = 50,
  namespace = 'NONE'
}) => {
  return http.get(`sales/v4/views/${objectTypeId}/pinned/view?namespace=${namespace}`, {
    query: {
      count
    }
  });
};
const fetchPinnedViews = registerQuery({
  fieldName: 'pinnedViews',
  args: ['objectTypeId', 'count', 'namespace'],
  fetcher: getPinnedViewDefinitions
});
const EMPTY_OBJECT = {};
export function usePinnedViews(options = EMPTY_OBJECT) {
  const [{
    objectTypeId
  }] = useDraftContext();
  const {
    skip = false,
    count,
    onSuccess,
    onError
  } = options;
  const _useQuery = useQuery(fetchPinnedViews, {
      skip,
      variables: {
        objectTypeId,
        count,
        namespace: 'NONE'
      },
      onCompleted: responseData => {
        if (responseData !== null && responseData !== void 0 && responseData.pinnedViews && onSuccess) {
          onSuccess(responseData.pinnedViews);
        }
      },
      onError
    }),
    {
      data,
      loading,
      error
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const client = useDataFetchingClient();
  useEffect(() => {
    var _data$pinnedViews;
    if (Array.isArray(data === null || data === void 0 || (_data$pinnedViews = data.pinnedViews) === null || _data$pinnedViews === void 0 ? void 0 : _data$pinnedViews.results)) {
      data.pinnedViews.results.filter(view => Object.prototype.hasOwnProperty.call(view, 'name')).forEach(view => {
        writeViewToCache(view, client, {
          overwrite: false
        });
      });
    }
  }, [data, client]);
  return useMemo(() => Object.assign({
    data: (data === null || data === void 0 ? void 0 : data.pinnedViews) || null,
    loading,
    error
  }, rest), [data, loading, error, rest]);
}